module.exports = __webpack_public_path__ + "img/climas.b38a88c9.png";